/**
 * Set of constants that define location descriptor state keys.
 */

// Should be used as an instruction to not perform an async data fetch upon a route change.
export const doNotFetch = 'doNotFetch';

// An instruction to disable the loading state for a route that's initiated via an async data fetch.
export const disableLoadingState = 'disableLoadingState';
